<template>
  <div>
    <apexchart
        :height="chartOptions.chart?.height || 400"
        :options="options"
        :series="series"
        @click="onMarkerClick"
        class="chart"
    ></apexchart>
  </div>
</template>

<script setup>
import { toRefs, computed, defineProps } from "vue"
const props = defineProps( {
  chartOptions: {
    default: {}
  },
  chartSeries: {
    default: () => []
  }
})
const {chartOptions, chartSeries: series}= toRefs(props)

const options = computed(() => ({
  chart: {
    height: chartOptions.value.chart?.height || 100,
    type: "line",
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    }
  },
  yaxis: {
    logarithmic: false,
  },
  xaxis: {
    type: "datetime",
    tickAmount: Math.min(props.chartSeries.length, 12)
  },

  dataLabels: {
    enabled: !!chartOptions.value.dataLabel?.enabled,
    offsetY: -10,
    enabledOnSeries: chartOptions.value.dataLabel?.enabledOnSeries || [],
    formatter: function (val) {
      if (parseInt(val) === 0) return ``
      return `${val.toFixed(2)}`
    },
    style: {
      fontSize: '18px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 'normal',
      colors: undefined
    },
    background: {
      enabled: true,
      foreColor: '#fff',
      padding: 2,
      borderRadius: 4,
      borderWidth: 0,
      //borderColor: '#fff',
      opacity: 0.9,
      // dropShadow: {
      //   enabled: false,
      //   top: 1,
      //   left: 1,
      //   blur: 1,
      //   color: '#000',
      //   opacity: 0.45
      // }
    },
  },
  title: {
    text: chartOptions.value.title || ''
  },
  labels: chartOptions.value.labels || [],
  colors: chartOptions.value.colors || [],
  stroke: {
    width: chartOptions.value.stroke?.width || [],
    curve: 'smooth', //'monotoneCubic', //'smooth' // Use 'smooth' for basic curves, or 'monotoneCubic' for more control
  }
}))

function onMarkerClick(e, chartEvt, opts) {
  console.log(chartEvt, opts, opts.seriesIndex, series.value[opts.seriesIndex])
}

</script>



<style scoped lang="scss">

</style>
